import { render } from "./PageInstall.vue?vue&type=template&id=3f17fdbb"
import script from "./PageInstall.vue?vue&type=script&lang=js"
export * from "./PageInstall.vue?vue&type=script&lang=js"
script.render = render

export default script